var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-post hide-scrollbar render-post-bluesky",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("div", { staticClass: "container-post-content" }, [
        _c(
          "div",
          { staticClass: "post-content" },
          [
            _c("div", { staticClass: "post-header" }, [
              _c("div", { staticClass: "info" }, [
                _c(
                  "div",
                  { staticClass: "img-pages" },
                  [
                    _vm._l(
                      _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
                      function (page, index) {
                        return [
                          _c(
                            "Tooltip",
                            {
                              key: index,
                              attrs: {
                                active: page.iconEdited,
                                text: "Voir les modifications apportées",
                                position: "right",
                                classCustom: `page ${
                                  page.iconEdited ? "iconEdited" : ""
                                }`,
                              },
                              on: {
                                click: () => {
                                  page.iconEdited
                                    ? _vm.$emit("clickPage", page.id)
                                    : _vm.openBlueskyPage(page)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    page && page.avatar
                                      ? page.avatar
                                      : "img/avatar.jpg",
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ]
                      }
                    ),
                    _vm.pages.length > 4
                      ? _c("div", { staticClass: "page count" }, [
                          _vm._v(
                            "\n                            +" +
                              _vm._s(_vm.pages.length - 3) +
                              "\n                        "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _c("p", [
                  _vm.pages.length == 1
                    ? _c(
                        "span",
                        {
                          staticClass: "name",
                          on: {
                            click: function ($event) {
                              return _vm.openBlueskyPage(_vm.pages[0])
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.pages[0].name))]
                      )
                    : _vm._e(),
                  _vm.pages.length == 1
                    ? _c("span", { staticClass: "name2" }, [
                        _vm._v(_vm._s("@" + _vm.pages[0].name)),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._m(0),
            ]),
            _vm.text
              ? _c("div", { staticClass: "post-text" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.textTranslateMentionAndHastag),
                    },
                  }),
                ])
              : _vm._e(),
            _vm.medias.length &&
            _vm.medias.find(
              (m) =>
                ["image", "video"].includes(m.info.type2) &&
                m.info.type !== "image/gif"
            )
              ? _c(
                  "div",
                  { class: "post-medias media" + _vm.medias.length },
                  _vm._l(_vm.medias, function (media) {
                    return _c("div", { key: media.id, staticClass: "media" }, [
                      media.info.type.startsWith("video/")
                        ? _c(
                            "div",
                            {
                              staticClass: "media-video",
                              class: {
                                videoPlayed: _vm.videoPlayed == media.id,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlayPause(media.id)
                                },
                              },
                            },
                            [
                              media.imagePreview && _vm.videoPlayed !== media.id
                                ? _c("img", {
                                    staticClass: "imagePreview",
                                    attrs: {
                                      src: media.imagePreview.url,
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _c("video", {
                                ref: "videoPlayer",
                                refInFor: true,
                                staticClass: "video",
                                attrs: {
                                  mediaId: media.id,
                                  playsinline: "",
                                  preload: "metadata",
                                  loop: "",
                                  autoPlay: _vm.videoPlayed == media.id,
                                  src: media.url,
                                  type: media.info.type,
                                },
                              }),
                            ]
                          )
                        : _c("img", { attrs: { src: media.url, alt: "" } }),
                    ])
                  }),
                  0
                )
              : !_vm.text
              ? _c("div", { staticClass: "post-empty" })
              : _vm._e(),
            _c("div", { staticClass: "post-footer" }, [
              _c("div", { staticClass: "top" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.datePost ? _vm.formatDatePost : "A l'instant")
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bottom" }, [
                _c("div", { staticClass: "comments" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        height: "auto",
                        width: "auto",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            d: "M1.751 10c0-4.42 3.584-8 8.005-8h4.366c4.49 0 8.129 3.64 8.129 8.13 0 2.96-1.607 5.68-4.196 7.11l-8.054 4.46v-3.69h-.067c-4.49.1-8.183-3.51-8.183-8.01zm8.005-6c-3.317 0-6.005 2.69-6.005 6 0 3.37 2.77 6.08 6.138 6.01l.351-.01h1.761v2.3l5.087-2.81c1.951-1.08 3.163-3.13 3.163-5.36 0-3.39-2.744-6.13-6.129-6.13H9.756z",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "share" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        height: "auto",
                        width: "auto",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            d: "M4.5 3.88l4.432 4.14-1.364 1.46L5.5 7.55V16c0 1.1.896 2 2 2H13v2H7.5c-2.209 0-4-1.79-4-4V7.55L1.432 9.48.068 8.02 4.5 3.88zM16.5 6H11V4h5.5c2.209 0 4 1.79 4 4v8.45l2.068-1.93 1.364 1.46-4.432 4.14-4.432-4.14 1.364-1.46 2.068 1.93V8c0-1.1-.896-2-2-2z",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "like" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        height: "auto",
                        width: "auto",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            d: "M16.697 5.5c-1.222-.06-2.679.51-3.89 2.16l-.805 1.09-.806-1.09C9.984 6.01 8.526 5.44 7.304 5.5c-1.243.07-2.349.78-2.91 1.91-.552 1.12-.633 2.78.479 4.82 1.074 1.97 3.257 4.27 7.129 6.61 3.87-2.34 6.052-4.64 7.126-6.61 1.111-2.04 1.03-3.7.477-4.82-.561-1.13-1.666-1.84-2.908-1.91zm4.187 7.69c-1.351 2.48-4.001 5.12-8.379 7.67l-.503.3-.504-.3c-4.379-2.55-7.029-5.19-8.382-7.67-1.36-2.5-1.41-4.86-.514-6.67.887-1.79 2.647-2.91 4.601-3.01 1.651-.09 3.368.56 4.798 2.01 1.429-1.45 3.146-2.1 4.796-2.01 1.954.1 3.714 1.22 4.601 3.01.896 1.81.846 4.17-.514 6.67z",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "signets" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        height: "auto",
                        width: "auto",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            d: "M4 4.5C4 3.12 5.119 2 6.5 2h11C18.881 2 20 3.12 20 4.5v18.44l-8-5.71-8 5.71V4.5zM6.5 4c-.276 0-.5.22-.5.5v14.56l6-4.29 6 4.29V4.5c0-.28-.224-.5-.5-.5h-11z",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._l(_vm.commentsTranslateMentionAndHastag, function (comment) {
              return _c("div", { staticClass: "comment-first" }, [
                _c("div", { staticClass: "image-auteur" }, [
                  _c("img", {
                    attrs: {
                      src:
                        !_vm.pages ||
                        !_vm.pages.length ||
                        _vm.pages.length > 1 ||
                        !_vm.pages[0]
                          ? "img/avatar.jpg"
                          : _vm.pages[0].avatar,
                      alt: "",
                    },
                  }),
                ]),
                _c("div", { staticClass: "content-comment" }, [
                  _c("p", [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.pages.length > 1
                            ? "Commentaire"
                            : _vm.pages[0].name
                        )
                      ),
                    ]),
                    _c("span", { staticClass: "name2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.pages.length > 1
                            ? "Commentaire"
                            : "@" + _vm.pages[0].name
                        )
                      ),
                    ]),
                    _vm._v(
                      "\n                        •\n                        "
                    ),
                    _c("span", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(
                          _vm.datePost ? _vm.formatDatePost : "A l'instant"
                        )
                      ),
                    ]),
                  ]),
                  _c("p", {
                    staticClass: "comment",
                    domProps: { innerHTML: _vm._s(comment) },
                  }),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "more" }, [
      _c("i", { staticClass: "fa-solid fa-ellipsis" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }